import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

var activateOpenFacets = function activateOpenFacets(cookies, store) {
  return store.state.sharedEnv.payload.mdmToggleOpenFacets === 'true' || !!(cookies && cookies.get('MDM_TOOGLE_OPENFACETS'));
};

export default activateOpenFacets;